import { render, staticRenderFns } from "./Hotel.vue?vue&type=template&id=b4cd8010&scoped=true&"
import script from "./Hotel.vue?vue&type=script&lang=js&"
export * from "./Hotel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4cd8010",
  null
  
)

export default component.exports